import React from 'react';
import { Link } from 'react-router-dom';
import { AVAILABLE_SCREENS } from '../../api/connection';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';
import './NotConnected.css';

/**
 * Shown in place of a screen whose backend API doesn't exist yet (backend mode only — see src/api/connection.js).
 * The screen stays in the sidebar so the product's shape is visible; it just has no data source yet.
 */
export default function NotConnected({ title, compact = false }) {
  const { can } = useWorkspace();
  const available = AVAILABLE_SCREENS.filter(([, , permission]) => !permission || can(permission));

  return (
    <section className={`cb-card cb-not-connected ${compact ? 'cb-not-connected--compact' : ''}`} role="status" aria-live="polite">
      <div className="cb-not-connected__icon" aria-hidden="true"><i className="bi bi-plug" /></div>
      <div className="cb-not-connected__body">
        <span className="badge rounded-pill cb-not-connected__badge">Coming soon</span>
        <h1 className="h4 fw-bold mt-2 mb-1">{title}</h1>
        <p className="text-muted mb-0">
          This screen isn't connected to the backend yet. It will start working as soon as its API is available.
        </p>
        {!compact && available.length > 0 && (
          <div className="mt-3">
            <p className="small fw-semibold mb-2">Available now</p>
            <div className="d-flex flex-wrap gap-2">
              {available.map(([to, label]) => (
                <Link key={to} to={to} className="btn btn-sm btn-outline-primary">{label}</Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
